import { GET_COMPANIES, RESET_COMPANIES, SET_COMPANY_SCORING } from "./types";

const initialState = {
  companies: [],
  scoring: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPANIES:
      return {
        ...state,
        companies: action.payload,
      };
    case RESET_COMPANIES:
      return {
        ...state,
        companies: [],
      };
      case SET_COMPANY_SCORING:
      return {
        ...state,
        scoring: action.payload,
      };
    default:
      return state;
  }
};
